import { ComplianceStatus, complianceStatusLabels as baseComplianceStatusLabels } from 'ah-api-gateways';

export const complianceStatusLabels: Record<ComplianceStatus, string> = {
  ...baseComplianceStatusLabels,
  [ComplianceStatus.APPROVED]: 'Active',
};
